module.exports = __webpack_public_path__ + "img/kefu@2x.5365a1dd.png";